import React from 'react'
import { Durations } from '@/constants/durations'
import { slugs } from '@/constants/slugs'
import { NextPageWithLayout } from '@/layouts/types'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { noPreRenderedStaticPaths } from '@/utils/nextUtils/staticPages'
import { loadTranslations } from '@/utils/translate/translate-server'
import { GiveawayTypographyProvider } from '@/views/PreSales/PreSalesGiveawayView/context/GiveawayTypographyProvider'
import Layout from '@/views/YoungWashingtonView/Layout'
import BattlefieldImage from '@/views/YoungWashingtonView/components/BattlefieldImage'
import BehindTheCamera from '@/views/YoungWashingtonView/components/BehindTheCamera'
import EmailSignup from '@/views/YoungWashingtonView/components/EmailSignup'
import Faq from '@/views/YoungWashingtonView/components/Faq'
import Footer from '@/views/YoungWashingtonView/components/Footer'
import Hero from '@/views/YoungWashingtonView/components/Hero'
import MakeHistory from '@/views/YoungWashingtonView/components/MakeHistory'

const YoungWashingtonView: NextPageWithLayout = () => {
  return (
    <GiveawayTypographyProvider theatricalSlug={slugs.youngWashington}>
      <main className="bg-slate-900 min-h-screen">
        <Hero />
        <MakeHistory />
        <BehindTheCamera />
        <BattlefieldImage />
        <EmailSignup />
        <Faq />
        <Footer />
      </main>
    </GiveawayTypographyProvider>
  )
}

YoungWashingtonView.getLayout = (page: React.ReactNode) => {
  return <Layout>{page}</Layout>
}

export const getStaticPaths = noPreRenderedStaticPaths

export const getStaticProps = getStaticPropsErrorHandler(
  { filePath: 'pages/[locale]/preorder/young-washington/index.tsx' },
  async ({ locale }) => {
    return {
      props: {
        ...(await loadTranslations(locale, ['common'])),
      },
      revalidate: Durations.ONE_DAY_IN_SECONDS,
    }
  },
)

export default YoungWashingtonView
